module.exports = __webpack_public_path__ + "media/brands/romet-c0cd6478.png";